import { useState } from 'react';
import { Grid, Typography, GTIWebDatePicker } from "@gti-controls-v2/web-core";

const DateRangeFilter = ({
	labelStart,
	labelEnd,
	labelTo,
	dateFormat,
	value,
	onChange,
}) => {
	/** Rango de fechas obtenido de GridView */
	const [rangeDateStart, setRangeDateStart] = useState(value.startDate);
	const [rangeDateEnd, setRangeDateEnd] = useState(value.endDate);


	const handleDateChange = (type) => (e) => {
		const date = e.target.value;

		if ((typeof date === 'string' && date.length === 10) || date instanceof Date) {
			const startDate = new Date(type === 'startDate' ? date : rangeDateStart);
			const endDate = new Date(type === 'endDate' ? date : rangeDateEnd);

			let newVal = { startDate: rangeDateStart, endDate: rangeDateEnd };
			newVal = { ...newVal, [type]: date }

			let fixBoth = false;

			if (type === 'startDate' && rangeDateEnd && endDate <= startDate) {
				const adjustedEnd = new Date(startDate);
				adjustedEnd.setDate(startDate.getDate() + 1);
				newVal = {
					startDate: date,
					endDate: adjustedEnd.toISOString().split('T')[0],
				};

				fixBoth = true
			} else if (type === 'endDate' && rangeDateStart && endDate < startDate) {
				const adjustedStart = new Date(endDate);
				adjustedStart.setDate(endDate.getDate() - 1);
				newVal = {
					startDate: adjustedStart.toISOString().split('T')[0],
					endDate: date,
				};

				fixBoth = true
			}

			if (fixBoth) {
				setRangeDateStart(newVal.startDate)
				setRangeDateEnd(newVal.endDate);
				onChange?.({ target: { name: 'dateRange', value: newVal } });
			} else {
				if (type === 'startDate' && rangeDateStart !== newVal.startDate) {
					setRangeDateStart(newVal.startDate)
					onChange?.({ target: { name: 'dateRange', value: newVal } });
				} 
				
				if (type === 'endDate' && rangeDateEnd !== newVal.endDate) {
					setRangeDateEnd(newVal.endDate);
					onChange?.({ target: { name: 'dateRange', value: newVal } });
				}
			}
		}
	};

	return (
		<Grid item xs={12}>
			<Grid container direction="row" alignItems="center" spacing={2}>
				<Grid item md={3} xs={6} sm={6} pr={2}>
					<GTIWebDatePicker
						name={'startDate'}
						inputFormat={dateFormat}
						labelText={labelStart}
						value={rangeDateStart}
						onChange={handleDateChange('startDate')}
						autoComplete={false}
					/>
				</Grid>
				<Grid>
					<Typography marginTop={labelStart && labelEnd && 3}>
						{labelTo}
					</Typography>
				</Grid>
				<Grid item md={3} xs={6} sm={6}>
					<GTIWebDatePicker
						name={'endDate'}
						inputFormat={dateFormat}
						labelText={labelEnd}
						value={rangeDateEnd}
						onChange={handleDateChange('endDate')}
					/>
				</Grid>
			</Grid>
		</Grid>
	);
}
export default DateRangeFilter;